import useSWR from "swr";

import { api } from "../services";


const BASE_URL = "/system-admin/leave-applications";
const UPDATE_URL = "/system-admin/leave-applications/status";

export const useLeaveApplication = ( query = {}) => {
  const qs = new URLSearchParams(query).toString();
  const { data, isLoading, mutate } = useSWR(`${BASE_URL}?${qs}`, api.get);
  const create = async (data) => {
    const positions = await api.post(BASE_URL, data);
    return positions;
  };
  const update = async (data) => {
    const positions = await api.patch(UPDATE_URL, data);
    return positions;
  };
  const find = async (query) => {
    const positions = await api.get(`${BASE_URL}/find?search=${query}`);
    return positions;
  };
  return {
    isLoading,
    data: data,
    count: data?.length,
    create,
    update,
    find,
    mutate,
  };
};